import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

interface SectionProps {
  readonly title: MessageKey;
  readonly className?: string;
  readonly children: ReactNode;
}

const Section = ({ title, className, children, ...props }: SectionProps) => {
  const t = useTranslations();

  return (
    <section className={cx('mt-8 mb-16', className)} {...props}>
      <Typography Element="h3" variant="h3" className="mb-8">
        {t(title)}
      </Typography>

      {children}
    </section>
  );
};

export default Section;
